{
  "pt": {
    "task": {
      "actions": {
        "create": "Tarefa",
        "create_and_send": "Criar e enviar",
        "save_as_draft": "Guardar como rascunho",
        "update": "Editar tarefa"
      },
      "attributes": {
        "assignments_count": "Atribuições",
        "category": "Forma de concluir",
        "created_at": "Criado em",
        "description": "Descrição",
        "title": "Título",
        "units": "Unidades"
      },
      "categories": {
        "confirmation": "Confirmação",
        "upload": "Carregamento de documento"
      },
      "categories_info": {
        "confirmation": "O responsável marca a tarefa assim que estiver feita.",
        "upload": "O responsável tem de carregar um documento para concluir a tarefa."
      },
      "labels": {
        "no_tasks": "Ainda não há tarefas para este projeto.",
        "required": "Este campo é obrigatório",
        "set_all_assignees": "Definir para o responsável | Definir para os {count} responsáveis",
        "still_to_do": "{count} por fazer",
        "units_count": "{count} unidade | {count} unidades",
        "units_required": "Selecione pelo menos uma unidade"
      },
      "toasts": {
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "update": "Tarefa atualizada"
      }
    }
  }
}
